import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchGetStartedVideos, fetchVideoCategories, clearMessage } from '../../../redux/slices/customer/videoSlice';
import Layout from '../Layout';
import '../../../global.css';
import arrowRight from '../../../images/icon-double-arrow-right.svg';
import arrowLeft from '../../../images/icon-double-arrow-left.svg';
import Back from '../../../components/common/Back';

const Videos = () => {
  const dispatch = useDispatch();
  const { videos, currentPage, totalPages, categories, errorMessage } = useSelector(
    (state) => state.customer_videos
  );

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentVideo, setCurrentVideo] = useState({ videoId: '', videoType: '' });
  const [activeCategory, setActiveCategory] = useState(1);

  useEffect(() => {
    dispatch(clearMessage());
  }, []); 

  useEffect(() => {
    dispatch(fetchVideoCategories({ page: 1 }));
    dispatch(fetchGetStartedVideos({ page: currentPage, category: activeCategory }));
  }, [dispatch, currentPage]);

  const handlePagination = (page) => {
    dispatch(fetchGetStartedVideos({ page, category: activeCategory }));
  };

  const openVideoModal = (videoId, videoType) => {
    setCurrentVideo({ videoId, videoType });
    setIsModalOpen(true);
  };

  const closeVideoModal = () => {
    setIsModalOpen(false);
    setCurrentVideo({ videoId: '', videoType: '' });
  };

  const renderVideoUrl = () => {
    const { videoId, videoType } = currentVideo;
    if (videoType === 'youtube') {
      return `https://www.youtube.com/embed/${videoId}?autoplay=1&mute=0&controls=1&showinfo=0&rel=0&iv_load_policy=3&modestbranding=1`;
    } else if (videoType === 'vimeo') {
      return `https://player.vimeo.com/video/${videoId}?autoplay=1&mute=0&controls=1`;
    }
    return '';
  };

  const filterCategory = (category) => {
    setActiveCategory(category.id); // Set active category
    dispatch(fetchGetStartedVideos({ page: 1, category: category.id })); 

  };

  return (
    <Layout>
      <main className="main" style={{ overflow: 'unset', height: '100vh' }}>
        <div className="card-entries mt-3">
          <header className="main-head flex justify-between align-center">
            <h1 className="greet-user-text">Get Started Videos</h1>
            <div className="ms-auto">
              <Back />
            </div>
          </header>

          <div className="tags_container videos">
            {categories.map((category) => (
              <a
                key={category.id}
                onClick={() => filterCategory(category)}
                className={`category-link ${activeCategory === category.id ? 'active' : ''}`}
              >
                {category.title}
              </a>
            ))}
          </div>

          <div className="main-content flex justify-between">
            <div className="phases-container">
              {errorMessage ? (
                <p className="error">{errorMessage}</p>
              ) : (
                <div className="card responsive-table-container p-0" style={{ width: '100%' }}>
                  <div className="row">
                    {videos && videos.map((video, index) => (
                      <div className="column" key={index}>
                        <div className="video_container">
                          <div
                            className="position-relative bg-black-video"
                            onClick={() => openVideoModal(video.video_id_type.video_id, video.video_id_type.video_type)}
                          >
                            <div className="videologo icon-circle-play">
                              <i className="bi bi-play-fill"></i>
                            </div>
                            <img
                              className="thumb-video"
                              src={video.web_thumbnail_full_url ? video.web_thumbnail_full_url : video.video_id_type.thumb}
                              alt={video.title}
                            />
                          </div>
                          <h3>{video.title}</h3>
                          <p>{video.description}</p>
                        </div>
                      </div>
                    ))}
                  </div>

                  <div className="col-12 text-center mt-4">
                    <div className="pagination-wrap">
                      <ul>
                        {currentPage > 1 && (
                          <li>
                            <a onClick={() => handlePagination(currentPage - 1)}>
                              <img src={arrowLeft} alt="Previous" />
                            </a>
                          </li>
                        )}
                        {[...Array(totalPages)].map((_, index) => {
                          const page = index + 1;
                          return (
                            <li key={page}>
                              <a
                                className={page === currentPage ? 'active' : ''}
                                onClick={() => handlePagination(page)}
                              >
                                {page}
                              </a>
                            </li>
                          );
                        })}
                        {currentPage < totalPages && (
                          <li>
                            <a onClick={() => handlePagination(currentPage + 1)}>
                              <img src={arrowRight} alt="Next" />
                            </a>
                          </li>
                        )}
                      </ul>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>

        {/* Modal for video */}
        {isModalOpen && (
          <div className="video-modal-overlay" onClick={closeVideoModal}>
            <div className="video-modal-content" onClick={(e) => e.stopPropagation()}>
              <button className="video-modal-close" onClick={closeVideoModal}>X</button>
              <div style={{ width: '100%', height: '100%' }}>
                <iframe
                  frameBorder="0"
                  allowFullScreen
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  src={renderVideoUrl()}
                  style={{ width: '100%', height: '100%' }}
                ></iframe>
              </div>
            </div>
          </div>
        )}
      </main>
    </Layout>
  );
};

export default Videos;